import React from 'react';
import { Tag, Tooltip } from '@chakra-ui/react';

// item 997 (Chad) — the internal marker that a document is VISIBLE in the customer portal.
// Purely informational: sharing is governed by the customer's external login + capabilities;
// this just makes that state impossible to miss internally.
const SharedToPortalChip: React.FC<{ what: string }> = ({ what }) => (
  <Tooltip label={`This customer has an active portal login with access to ${what} — they can see this.`} placement="top">
    <Tag size="sm" colorScheme="purple" variant="subtle" whiteSpace="nowrap" flexShrink={0}>
      SHARED TO PORTAL
    </Tag>
  </Tooltip>
);

export default SharedToPortalChip;
